// extracted by mini-css-extract-plugin
export default {"trendDetails":"trend_trendDetails__qgFgP"};